import { render, staticRenderFns } from "./PlaybackRateButton.vue?vue&type=template&id=6122ea74"
import script from "./PlaybackRateButton.vue?vue&type=script&lang=js"
export * from "./PlaybackRateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports